import request from "@/utils/request";

/**
 * 组员-获取企业报告列表
 *
 */
export function getMyReportRecords(data) {
  return request({
    url: "/Data/ReportTask/QueryMyReportRecords",
    method: "post",
    data: data,
  });
}
/**
 * 小组长-获取组员企业报告列表
 *
 */
export function getDepartmentReportRecords(data) {
  return request({
    url: "/Data/ReportTask/QueryDepartmentReportRecords",
    method: "post",
    data: data,
  });
}

/**
 * 管理员-获取所有企业报告列表
 *
 */
export function getAllReportRecords(data) {
  return request({
    url: "/Data/ReportTask/QueryAllReportRecords",
    method: "post",
    data: data,
  });
}

/**
 * 管理员/小组长-转移客户
 *
 */
export function getTransferCustomer(data) {
  return request({
    url: "/Data/ReportTask/TransferCustomer",
    method: "post",
    data: data,
  });
}

/**
 * 上传征信
 *
 */
export function getUploadFile(data) {
  return request({
    url: "/Data/ReportTask/UploadFile",
    method: "post",
    data: data,
  });
}

/**
 * 获取征信详情
 *
 */
export function getReportRecord(params) {
  return request({
    url: "/Data/ReportTask/GetReportRecord",
    method: "get",
    params: params,
  });
}

/**
 * 编辑征信
 *
 * @param data
 */
export function getUpdateReport(data) {
  return request({
    url: "/Data/ReportTask/Update",
    method: "post",
    data: data,
  });
}

/**
 * 创建征信
 *
 * @param data
 */
export function getCreateReport(data) {
  return request({
    url: "/Data/ReportTask/CreateReportRecord",
    method: "post",
    data: data,
  });
}
